import { render, staticRenderFns } from "./talentCell.vue?vue&type=template&id=45e5834c&scoped=true"
import script from "./talentCell.vue?vue&type=script&lang=js"
export * from "./talentCell.vue?vue&type=script&lang=js"
import style0 from "./talentCell.vue?vue&type=style&index=0&id=45e5834c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e5834c",
  null
  
)

export default component.exports